import { HttpParams } from '@angular/common/http';

export type HttpParamPrimitive = string | number | boolean;
export type HttpParamValue = HttpParamPrimitive | readonly HttpParamPrimitive[];

export type HttpParamInput = Record<string, HttpParamValue | undefined | null>;
export type HttpParamObject = Record<string, HttpParamValue>;

/**
 * Returns a new object without keys whose value is undefined or null.
 * Keeps false, 0, empty string, and empty arrays.
 */
export function omitUnallowedParamsObject(params: HttpParamInput): HttpParamObject {
  const cleaned: HttpParamObject = {};

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      cleaned[key] = value;
    }
  }

  return cleaned;
}

/**
 * Builds Angular HttpParams from a plain object, skipping undefined and null values.
 */
export function toHttpParams(params: HttpParamInput): HttpParams {
  return new HttpParams({
    fromObject: omitUnallowedParamsObject(params),
  });
}

export const appendHttpParamsFromObject = <T>(obj: T, params: HttpParams = new HttpParams()): HttpParams => {
  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((arrayValue) => {
        params = params.append(key, arrayValue);
      });
    } else if (value !== undefined && value !== null) {
      params = params.append(key, value);
    }
  });

  return params;
};
